export default "__VITE_ASSET__CZzwK8bc__"